import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Typography } from "@material-ui/core";

export default function SetPlayerTrackerStatsDialog({
  openState,
  userContext,
  onClose,
  onSetPlayerStats,
}) {
  if ("row" in userContext) {
    const [valveTotalMatchesPlayed, setValveTotalMatchesPlayed] = useState(
      userContext.row.valveTotalMatchesPlayed || ""
    );

    const [valveTotalMatchesWon, setValveTotalMatchesWon] = useState(
      userContext.row.valveTotalMatchesWon || ""
    );

    const [valveTotalMatchesLost, setValveTotalMatchesLost] = useState(
      userContext.row.valveTotalMatchesLost || ""
    );

    const [faceitTotalMatchesPlayed, setFaceitTotalMatchesPlayed] = useState(
      userContext.row.faceitTotalMatchesPlayed || ""
    );

    const [faceitTotalMatchesLost, setFaceitTotalMatchesLost] = useState(
      userContext.row.faceitTotalMatchesLost || ""
    );

    const [btnDisabled, setBtnDisabled] = useState(false);

    return (
      <div>
        {"row" in userContext && (
          <Dialog
            open={openState}
            onClose={onClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Set tracker stats for {userContext.row.nickname}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please update all the fields for the user
              </DialogContentText>

              <TextField
                autoFocus
                margin="dense"
                onChange={(e) => {
                  setValveTotalMatchesPlayed(e.target.value);
                }}
                value={valveTotalMatchesPlayed}
                label="Valve MM matches played"
                type="number"
                fullWidth
              />

              <div style={{ height: 10 }}></div>

              <TextField
                autoFocus
                margin="dense"
                onChange={(e) => {
                  setValveTotalMatchesWon(e.target.value);
                }}
                value={valveTotalMatchesWon}
                label="Valve MM matches won"
                type="number"
                fullWidth
              />

              <div style={{ height: 10 }}></div>

              <TextField
                autoFocus
                margin="dense"
                onChange={(e) => {
                  setValveTotalMatchesLost(e.target.value);
                }}
                value={valveTotalMatchesLost}
                label="Valve MM matches lost"
                type="number"
                fullWidth
              />

              <div style={{ height: 10 }}></div>

              <TextField
                autoFocus
                margin="dense"
                onChange={(e) => {
                  setFaceitTotalMatchesPlayed(e.target.value);
                }}
                value={faceitTotalMatchesPlayed}
                label="FaceIT matches played"
                type="number"
                fullWidth
              />

              <div style={{ height: 10 }}></div>

              <TextField
                autoFocus
                margin="dense"
                onChange={(e) => {
                  setFaceitTotalMatchesLost(e.target.value);
                }}
                value={faceitTotalMatchesLost}
                label="FaceIT matches lost"
                type="number"
                fullWidth
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} color="primary">
                Dismiss
              </Button>
              <Button
                disabled={btnDisabled}
                onClick={() => {
                  setBtnDisabled(true);
                  onSetPlayerStats(
                    {
                      faceitTotalMatchesLost,
                      faceitTotalMatchesPlayed,
                      valveTotalMatchesLost,
                      valveTotalMatchesWon,
                      valveTotalMatchesPlayed,
                    },
                    userContext.row.userId
                  );
                  setTimeout(() => {
                    setBtnDisabled(false);
                  }, 5 * 1000);
                }}
                color="primary"
              >
                Save Changes
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    );
  }

  return <></>;
}
